<div class="modal">
    <div class="header">
        <div class="smash-logo">
            <i class="icon-smash_icologo_chip"></i>
        </div>
        <div class="title title-big">{{ 'MODAL_2GO_QUEUE_TITLE' | translate }}</div>
        <p class="subtitle">{{ 'MODAL_2GO_QUEUE_SUBTITLE' | translate }}</p>
    </div>
    <div class="body">
        <div class="timer-block">
            <div class="timer-label">{{ 'MODAL_2GO_REMAINING_TIME_LABEL' | translate }}</div>
            <div class="timer" *ngIf="timer?.asMilliseconds() > 0">{{ timerFormat }}</div>
            <div class="timer over" *ngIf="timer?.asMilliseconds() <= 0">{{ 'MODAL_2GO_TIMER_OVER' | translate }}</div>
        </div>
        <button id="modal-size-premium-button-freemium" class="btn-new cta-send"
            [disabled]="(status$ | async) !== 'Resumable'" (click)="onUploadAnonymous()">
            <ng-container *ngIf="(uploadFormMode$ | async) === 'Link'; else emailLabel">{{
                'MODAL_2GO_BUTTON_GET_LINK_FREE' | translate }}</ng-container>
            <ng-template #emailLabel>{{ 'MODAL_2GO_BUTTON_SEND_FILES_FREE' | translate }}</ng-template>
        </button>
        <a id="modal-size-premium-link-pricing" class="cta-upgrade"
            (click)="goSubscribe($event, 'MODAL_2GO_BUTTON_SUBSCRIBE_LINK')">
            <span class="cta-upgrade-title">{{ 'MODAL_2GO_BUTTON_SUBSCRIBE' | translate }}</span>
            <span class="cta-upgrade-subtitle">{{ 'MODAL_2GO_UPGRADE_SUBTITLE' | translate }}</span>
        </a>
    </div>
    <div class="footer">
        <a class="cta-close" (click)="onCloseModal()">{{ 'MODAL_2GO_BUTTON_CLOSE' | translate }}</a>
    </div>
</div>
